import { h } from 'preact';
import Store from 'store/store';
import * as BaseComp from 'components/bolt/burgerMenu/burgerMenu.js';
import s from 'components/bolt/burgerMenu/burgerMenu.sss';
import HTML from 'components/core/html/html';
import { joinClasses } from 'utils/utils';

export default class BurgerMenu extends BaseComp.default {

	constructor(...args) {
		super(...args);

		this.state = {
			...this.state,
			scrolledALittleBit: false
		};
		
		this.shrinkOnScroll = this.shrinkOnScroll.bind(this);
	}

	componentDidMount() {
		window.addEventListener('scroll', this.shrinkOnScroll, true);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.shrinkOnScroll);
	}

	shrinkOnScroll(e) {
		const store = Store.get();
		const { client } = store;

		if (client?.deviceSize === 'desktop')
			return;

		const isMobile = client.deviceSize === 'mobile';
		const isTablet = client.deviceSize === 'tablet';
		if (isMobile) {
			this.setState({ scrolledALittleBit: e.target.scrollTop > 70 ? true : false});
		}
		if (isTablet) {
			this.setState({ scrolledALittleBit: e.target.scrollTop > 220 ? true : false});
		}
	}

	render(props) {
		const {
			type,
			style,
			lineStyle,
			dark,
			hidden,
			showtimesOverlayOpen,
			homeEntOverlayOpen,
			pressKitOverlayOpen,
			widgetFullyExpanded,
			navOpen,
			homeScrolled,
			isSinglePageIframed,
			showtimesSearchOverlay,
			videoOverlayOpen,
			oneSheetOverlay,
			oneSheetOverlayOpen,
			trailerOverlayOpen,
			trailerOverlay,
			calendarRemind,
			calendarRemindOpen,
			extraClass,
			customBurgerMenu
		} = props;

		const { scrolledALittleBit } = this.state;

		return (
			<div
				class={joinClasses(
					s.container,
					s[type],
					dark && s.dark,
					(showtimesOverlayOpen || widgetFullyExpanded) && s.showtimes,
					homeEntOverlayOpen && s.homeEnt,
					pressKitOverlayOpen && s.pressKit,
					navOpen && s.navOpen,
					homeScrolled && s.homeScrolled,
					(isSinglePageIframed || hidden) && s.hidden,
					showtimesSearchOverlay && s.searching,
					videoOverlayOpen && s.video,
					oneSheetOverlay && s.oneSheetOverlay,
					oneSheetOverlayOpen && s.oneSheetOverlayOpen,
					trailerOverlayOpen && s.trailerOverlayOpen,
					trailerOverlay && s.trailerOverlay,
					calendarRemindOpen && s.calendarRemindOpen,
					calendarRemind && s.calendarRemind,
					customBurgerMenu && s.customBurgerMenu,
					scrolledALittleBit && s.scrolledALittleBit,
					extraClass
				)}
				style={style}
			>
				{!customBurgerMenu?.icon ? (
					<div>
						<div style={lineStyle} class={s.line} />
						<div style={lineStyle} class={s.line} />
						<div style={lineStyle} class={s.line} />
					</div>
				) : (
					<HTML tag="div" markdown>{customBurgerMenu?.icon}</HTML>
				)}
			</div>
		);
	}
}
